import Info from '@mui/icons-material/Info';
import { IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
import { MeasurableBerriesInfoDialog } from './MeasurableBerriesInfoDialog';
export const MeasurableBerriesInfoLabel = ({
  measurableBerries,
  totalBerries,
}: {
  measurableBerries: number;
  totalBerries: number;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack
        direction={'row'}
        gap={0.5}
        alignItems={'center'}
        justifyContent={'flex-end'}
        flexWrap={'wrap'}
        height={'40px'}
      >
        <Typography
          noWrap
          fontSize={'0.75rem'}
          fontWeight={600}
          sx={{ color: (theme) => theme.colors.canopy.text.secondary }}
        >
          {t('Total measurable berries')}:
        </Typography>
        <Stack direction={'row'} gap={0.5} alignItems={'center'}>
          <Typography
            fontSize={'0.75rem'}
            fontWeight={600}
          >{`${measurableBerries.toLocaleString()} ${t(
            'of'
          )} ${totalBerries.toLocaleString()}`}</Typography>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              height: '1rem',
              width: '1rem',
              color: (theme) => theme.colors.canopy.content.icon,
            }}
          >
            <Info sx={{ height: '1rem', width: '1rem' }} />
          </IconButton>
        </Stack>
      </Stack>
      <MeasurableBerriesInfoDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
